var _circle, _rect, _rect2, _rect3, _path, _path2, _rect4, _rect5, _rect6, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmptyReaders(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 124,
    height: 106,
    viewBox: "0 0 124 106",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 61.9998,
    cy: 53,
    r: 53,
    fill: "#D1D1D1"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 66.4027,
    y: 15.019,
    width: 10.2877,
    height: 1.87049,
    rx: 0.935246,
    transform: "rotate(-45 66.4027 15.019)",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 57.1444,
    y: 16.3416,
    width: 10.2877,
    height: 1.87049,
    rx: 0.935245,
    transform: "rotate(-135 57.1444 16.3416)",
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 61.4836,
    y: 13.1416,
    width: 10.6618,
    height: 1.77697,
    rx: 0.888483,
    transform: "rotate(-90 61.4836 13.1416)",
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.06505 55.1259C5.35794 55.4188 5.83281 55.4188 6.12571 55.1259C6.4186 54.833 6.4186 54.3582 6.12571 54.0653L4.23327 52.1728L6.12568 50.2804C6.41857 49.9875 6.41857 49.5127 6.12568 49.2198C5.83278 48.9269 5.35791 48.9269 5.06502 49.2198L3.17262 51.1122L1.28012 49.2197C0.987223 48.9268 0.512349 48.9268 0.219456 49.2197C-0.0734371 49.5126 -0.0734366 49.9874 0.219457 50.2803L2.11195 52.1728L0.219426 54.0654C-0.0734674 54.3583 -0.0734674 54.8331 0.219426 55.126C0.512319 55.4189 0.987193 55.4189 1.28009 55.126L3.17262 53.2335L5.06505 55.1259Z",
    fill: "#2F343D",
    fillOpacity: 0.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M119.173 61.991C118.943 62.2218 118.943 62.596 119.173 62.8267C119.404 63.0575 119.778 63.0575 120.009 62.8267L121.5 61.336L122.991 62.8268C123.222 63.0575 123.596 63.0575 123.827 62.8268C124.057 62.596 124.057 62.2218 123.827 61.991L122.336 60.5002L123.827 59.0088C124.058 58.778 124.058 58.4039 123.827 58.1731C123.596 57.9423 123.222 57.9423 122.991 58.1731L121.5 59.6645L120.009 58.1731C119.778 57.9423 119.404 57.9423 119.173 58.1731C118.942 58.4039 118.942 58.778 119.173 59.0088L120.664 60.5002L119.173 61.991Z",
    fill: "#2F343D",
    fillOpacity: 0.6
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 21.9998,
    y: 7.30688,
    width: 7.50525,
    height: 1.39773,
    rx: 0.698864,
    transform: "rotate(-45 21.9998 7.30688)",
    fill: "#2F343D",
    fillOpacity: 0.6
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 109.596,
    y: 48.7903,
    width: 7.91522,
    height: 1.68777,
    rx: 0.843883,
    transform: "rotate(-135 109.596 48.7903)",
    fill: "#2F343D",
    fillOpacity: 0.6
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 11.9998,
    y: 79.9575,
    width: 7.91522,
    height: 1.68777,
    rx: 0.843883,
    transform: "rotate(-30 11.9998 79.9575)",
    fill: "#2F343D",
    fillOpacity: 0.6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4998 26.6C11.1073 26.6 11.5998 26.1075 11.5998 25.5C11.5998 24.8925 11.1073 24.4 10.4998 24.4C9.89224 24.4 9.39976 24.8925 9.39976 25.5C9.39976 26.1075 9.89224 26.6 10.4998 26.6ZM10.4998 28C11.8805 28 12.9998 26.8807 12.9998 25.5C12.9998 24.1193 11.8805 23 10.4998 23C9.11904 23 7.99976 24.1193 7.99976 25.5C7.99976 26.8807 9.11904 28 10.4998 28Z",
    fill: "#FF4935"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103 20C103.552 20 104 19.5523 104 19C104 18.4477 103.552 18 103 18C102.447 18 102 18.4477 102 19C102 19.5523 102.447 20 103 20ZM103 22C104.657 22 106 20.6569 106 19C106 17.3431 104.657 16 103 16C101.343 16 99.9998 17.3431 99.9998 19C99.9998 20.6569 101.343 22 103 22Z",
    fill: "#2F343D",
    fillOpacity: 0.6
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.5 87C111.328 87 112 86.3284 112 85.5C112 84.6716 111.328 84 110.5 84C109.671 84 109 84.6716 109 85.5C109 86.3284 109.671 87 110.5 87ZM110.5 89C112.433 89 114 87.433 114 85.5C114 83.567 112.433 82 110.5 82C108.567 82 107 83.567 107 85.5C107 87.433 108.567 89 110.5 89Z",
    fill: "#FF4935"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.9998 93.6588V31.3186C31.252 31.3149 34.3699 30.0159 36.6696 27.7065C38.9692 25.3971 40.2628 22.266 40.2664 19H84.7331C84.7296 20.6179 85.0457 22.2204 85.6631 23.7148C86.2804 25.2092 87.1867 26.5658 88.3295 27.7061C89.465 28.8542 90.816 29.7646 92.3043 30.3847C93.7925 31.0048 95.3885 31.3222 96.9998 31.3186V92.8004C87.6639 101.017 75.4138 106 61.9998 106C49.0595 106 37.2024 101.362 27.9998 93.6588Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M72.2331 73.4333H52.2998C51.0295 73.4333 49.9998 74.4631 49.9998 75.7333C49.9998 77.0036 51.0295 78.0333 52.2998 78.0333H72.2331C73.5033 78.0333 74.5331 77.0036 74.5331 75.7333C74.5331 74.4631 73.5033 73.4333 72.2331 73.4333Z",
    fill: "#2F343D",
    fillOpacity: 0.6
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M79.0331 82.6333H45.2998C44.0295 82.6333 42.9998 83.663 42.9998 84.9333C42.9998 86.2036 44.0295 87.2333 45.2998 87.2333H79.0331C80.3033 87.2333 81.3331 86.2036 81.3331 84.9333C81.3331 83.663 80.3033 82.6333 79.0331 82.6333Z",
    fill: "#2F343D",
    fillOpacity: 0.8
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.0947 54.6978C63.1281 56.0146 60.7629 56.7826 58.2183 56.7826C51.384 56.7826 45.8438 51.2423 45.8438 44.408C45.8438 37.5737 51.384 32.0334 58.2183 32.0334C65.0526 32.0334 70.5929 37.5737 70.5929 44.408C70.5929 47.0299 69.7775 49.4613 68.3865 51.4626L78.3591 60.0723C79.3205 60.9024 79.4271 62.3548 78.597 63.3163C77.7669 64.2778 76.3145 64.3843 75.353 63.5542L65.0947 54.6978Z",
    fill: "url(#paint0_linear_2815_1727)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M56.0857 47.2756H57.9878L58.0088 46.5433C58.0088 45.5808 58.6155 45.3298 59.4734 45.0578C60.3339 44.813 61.0914 44.2947 61.6312 43.5812C62.171 42.8677 62.4638 41.9979 62.4654 41.1032C62.4843 40.557 62.3895 40.0128 62.1871 39.5051C61.9848 38.9974 61.6792 38.5372 61.2898 38.1537C60.9004 37.7701 60.4356 37.4716 59.9248 37.277C59.4141 37.0825 58.8685 36.996 58.3226 37.0232C57.7457 37.0106 57.1723 37.1154 56.6371 37.3311C56.1018 37.5468 55.616 37.8689 55.2091 38.278C54.8021 38.6871 54.4825 39.1746 54.2696 39.7109C54.0567 40.2473 53.955 40.8212 53.9706 41.3981H55.9373C55.9299 41.0796 55.9861 40.7628 56.1026 40.4663C56.2191 40.1698 56.3937 39.8995 56.616 39.6714C56.8383 39.4432 57.104 39.2617 57.3973 39.1375C57.6907 39.0133 58.0059 38.9489 58.3245 38.9481C58.6118 38.9315 58.8993 38.9769 59.1675 39.0812C59.4357 39.1856 59.6783 39.3464 59.8788 39.5529C60.0793 39.7593 60.233 40.0065 60.3294 40.2776C60.4259 40.5488 60.4628 40.8375 60.4378 41.1242C60.4251 41.5882 60.2637 42.0359 59.9775 42.4013C59.6912 42.7666 59.2951 43.0304 58.8476 43.1537L58.1571 43.4276C57.4811 43.5905 56.8909 44.0013 56.5034 44.5787C56.1159 45.1561 55.9594 45.8579 56.0648 46.5452L56.0857 47.2756ZM57.0273 51.797C57.2135 51.8036 57.3992 51.7728 57.5734 51.7064C57.7475 51.64 57.9066 51.5394 58.0412 51.4105C58.1758 51.2816 58.2832 51.127 58.357 50.9558C58.4308 50.7847 58.4696 50.6005 58.471 50.4141C58.4693 50.2279 58.4304 50.0439 58.3564 49.873C58.2825 49.7021 58.1751 49.5477 58.0405 49.419C57.9059 49.2903 57.747 49.1898 57.5729 49.1236C57.3989 49.0573 57.2134 49.0266 57.0273 49.0332C56.8412 49.0266 56.6556 49.0573 56.4816 49.1236C56.3076 49.1898 56.1486 49.2903 56.014 49.419C55.8794 49.5477 55.772 49.7021 55.6981 49.873C55.6242 50.0439 55.5852 50.2279 55.5835 50.4141C55.585 50.6005 55.6237 50.7847 55.6975 50.9558C55.7714 51.127 55.8787 51.2816 56.0133 51.4105C56.1479 51.5394 56.307 51.64 56.4812 51.7064C56.6553 51.7728 56.841 51.8036 57.0273 51.797Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2815_1727",
    x1: 46.7034,
    y1: 64.1133,
    x2: 75.6921,
    y2: 59.6797,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4935"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EC6759"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyReaders);
export default __webpack_public_path__ + "static/media/empty-readers.95fae127da4b37e9b6a651acf76cacb0.svg";
export { ForwardRef as ReactComponent };